import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';

import PageWrapper from '../../components/PageWrapper';
import MenuAbout from '../../components/MenuAbout';
import InsideHeader from '../../components/InsideHeader';
import WelcomeSection from '../../components/WelcomeSection';
import ProcessListAlt from '../../components/ProcessListAlt';

function OurBuyingProcess({ page }) {
  const welcome = get(page, 'welcome_section[0]');
  return (
    <PageWrapper>
      <PageHelmet page={page} />
      <InsideHeader
        h1={`${page.meta.name}`}
        background={get(page, 'page_image')}
      />
      <MenuAbout />
      <WelcomeSection
        title={get(welcome, 'title')}
        lead={get(welcome, 'lead_copy')}
        image={get(welcome, 'image.contentUrl')}
      />
      <ProcessListAlt content={get(page, 'process_section[0]')} />
    </PageWrapper>
  );
}

OurBuyingProcess.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData(
  {
    page: 'our_buying_process',
  },
  {
    ifMissing404: true,
  },
)(OurBuyingProcess);



// WEBPACK FOOTER //
// ./src/pages/OurBuyingProcess/index.js